export const telemetryData = {
  generatedAt: 1767524121,
  chains: ["Arbitrum"],
  entities: [
    {
      id: 1,
      slug: "aave-aarbusdc",
      protocol: "Aave",
      protocolKey: "aave",
      chainId: 42161,
      chain: "Arbitrum",
      label: "Aave aArbUSDC",
      address: "0x724dc807b04555b71ed48a6896b6f41593b8c637",
      primaryMetric: "aave_supply_raw",
      secondaryMetrics: []
    },
    {
      id: 2,
      slug: "uniswap-usdc-usdt",
      protocol: "Uniswap",
      protocolKey: "uniswap",
      chainId: 42161,
      chain: "Arbitrum",
      label: "UniV3 Pool USDC/USDT 0.01% (Arbitrum)",
      address: "0xbe3ad6a5669dc0b8b12febc03608860c31e2eef6",
      primaryMetric: "uni_price",
      secondaryMetrics: ["uni_liquidity"]
    },
    {
      id: 3,
      slug: "uniswap-weth-usdc",
      protocol: "Uniswap",
      protocolKey: "uniswap",
      chainId: 42161,
      chain: "Arbitrum",
      label: "UniV3 Pool WETH/USDC 0.05% (Arbitrum)",
      address: "0xc6962004f452be9203591991d15f6b388e09e8d0",
      primaryMetric: "uni_price",
      secondaryMetrics: ["uni_liquidity"]
    },
    {
      id: 4,
      slug: "camelot-weth-arb",
      protocol: "Camelot",
      protocolKey: "camelot",
      chainId: 42161,
      chain: "Arbitrum",
      label: "Camelot V2 Pair WETH/ARB (Arbitrum)",
      address: "0xa6c5c7d189fa4eb5af8ba34e63dcdd3a635d433f",
      primaryMetric: "camelot_depth",
      secondaryMetrics: ["camelot_reserve0", "camelot_reserve1"]
    }
  ],
  analyticsSeries: [
    { entityId: 1, metric: "aave_supply_raw", ts: 1767441600, value: "302112554991203", period: "hour" },
    { entityId: 1, metric: "aave_supply_raw", ts: 1767445200, value: "301400302017813", period: "hour" },
    { entityId: 1, metric: "aave_supply_raw", ts: 1767448800, value: "301829166084744", period: "hour" },
    { entityId: 1, metric: "aave_supply_raw", ts: 1767513600, value: "300312991719505", period: "hour" },

    { entityId: 2, metric: "uni_price", ts: 1767441600, value: "1.000289114872901742", period: "hour" },
    { entityId: 2, metric: "uni_price", ts: 1767445200, value: "1.000271998441902617", period: "hour" },
    { entityId: 2, metric: "uni_price", ts: 1767448800, value: "1.000277439073827825", period: "hour" },
    { entityId: 2, metric: "uni_price", ts: 1767513600, value: "1.000265356009459282", period: "hour" },
    { entityId: 2, metric: "uni_liquidity", ts: 1767441600, value: "6521048835124300", period: "hour" },
    { entityId: 2, metric: "uni_liquidity", ts: 1767445200, value: "6550029441100000", period: "hour" },
    { entityId: 2, metric: "uni_liquidity", ts: 1767448800, value: "6603852949718277", period: "hour" },
    { entityId: 2, metric: "uni_liquidity", ts: 1767513600, value: "6992771963125713", period: "hour" },

    { entityId: 3, metric: "uni_price", ts: 1767441600, value: "3092.221614993740112244", period: "hour" },
    { entityId: 3, metric: "uni_price", ts: 1767445200, value: "3098.402118340121199921", period: "hour" },
    { entityId: 3, metric: "uni_price", ts: 1767448800, value: "3108.105877073950292828", period: "hour" },
    { entityId: 3, metric: "uni_price", ts: 1767513600, value: "3131.571673709465497210", period: "hour" },
    { entityId: 3, metric: "uni_liquidity", ts: 1767441600, value: "7811148891000000000", period: "hour" },
    { entityId: 3, metric: "uni_liquidity", ts: 1767445200, value: "7880000000000000000", period: "hour" },
    { entityId: 3, metric: "uni_liquidity", ts: 1767448800, value: "7952143359762911055", period: "hour" },
    { entityId: 3, metric: "uni_liquidity", ts: 1767513600, value: "8215612289467157191", period: "hour" },

    { entityId: 4, metric: "camelot_depth", ts: 1767445200, value: "118974376739894829383592", period: "hour" },
    { entityId: 4, metric: "camelot_depth", ts: 1767448800, value: "118974323390679509105189", period: "hour" },
    { entityId: 4, metric: "camelot_depth", ts: 1767513600, value: "118804911084751088759095", period: "hour" },
    { entityId: 4, metric: "camelot_reserve0", ts: 1767445200, value: "7930002227284994410", period: "hour" },
    { entityId: 4, metric: "camelot_reserve0", ts: 1767448800, value: "7930005794349216190", period: "hour" },
    { entityId: 4, metric: "camelot_reserve0", ts: 1767513600, value: "7941773076080453785", period: "hour" },
    { entityId: 4, metric: "camelot_reserve1", ts: 1767445200, value: "118966446737667544389182", period: "hour" },
    { entityId: 4, metric: "camelot_reserve1", ts: 1767448800, value: "118966393384885159888999", period: "hour" },
    { entityId: 4, metric: "camelot_reserve1", ts: 1767513600, value: "118796969311675008305310", period: "hour" }
  ],
  snapshots: [
    {
      entityId: 1,
      metric: "totalSupply",
      value: "300312991719505",
      blockNumber: 210039221,
      timestamp: 1767515239
    },
    {
      entityId: 1,
      metric: "totalSupply",
      value: "301829166084744",
      blockNumber: 210035102,
      timestamp: 1767511202
    },
    {
      entityId: 1,
      metric: "totalSupply",
      value: "301400302017813",
      blockNumber: 210029884,
      timestamp: 1767445320
    },
    {
      entityId: 1,
      metric: "totalSupply",
      value: "302112554991203",
      blockNumber: 210028411,
      timestamp: 1767441741
    },
    {
      entityId: 1,
      metric: "totalSupply",
      value: "302640114129880",
      blockNumber: 210024903,
      timestamp: 1767438022
    },

    {
      entityId: 2,
      metric: "slot0.sqrtPriceX96",
      value: "79175034681090007269240000000",
      blockNumber: 210039221,
      timestamp: 1767515239
    },
    {
      entityId: 2,
      metric: "slot0.tick",
      value: "-12",
      blockNumber: 210039221,
      timestamp: 1767515239
    },
    {
      entityId: 2,
      metric: "liquidity",
      value: "6992771963125713",
      blockNumber: 210039221,
      timestamp: 1767515239
    },
    {
      entityId: 2,
      metric: "slot0.sqrtPriceX96",
      value: "79175999011239902011211000000",
      blockNumber: 210035102,
      timestamp: 1767511202
    },
    {
      entityId: 2,
      metric: "liquidity",
      value: "6603852949718277",
      blockNumber: 210035102,
      timestamp: 1767511202
    },

    {
      entityId: 3,
      metric: "slot0.sqrtPriceX96",
      value: "140737889602633383110000000000",
      blockNumber: 210039221,
      timestamp: 1767515239
    },
    {
      entityId: 3,
      metric: "slot0.tick",
      value: "201116",
      blockNumber: 210039221,
      timestamp: 1767515239
    },
    {
      entityId: 3,
      metric: "liquidity",
      value: "8215612289467157191",
      blockNumber: 210039221,
      timestamp: 1767515239
    },
    {
      entityId: 3,
      metric: "slot0.sqrtPriceX96",
      value: "139901238112903401230000000000",
      blockNumber: 210035102,
      timestamp: 1767511202
    },
    {
      entityId: 3,
      metric: "liquidity",
      value: "7952143359762911055",
      blockNumber: 210035102,
      timestamp: 1767511202
    },

    {
      entityId: 4,
      metric: "reserve0",
      value: "7941773076080453785",
      blockNumber: 210039221,
      timestamp: 1767515239
    },
    {
      entityId: 4,
      metric: "reserve1",
      value: "118796969311675008305310",
      blockNumber: 210039221,
      timestamp: 1767515239
    },
    {
      entityId: 4,
      metric: "reserveBlockTimestamp",
      value: "1767515239",
      blockNumber: 210039221,
      timestamp: 1767515239
    },
    {
      entityId: 4,
      metric: "totalSupply",
      value: "166234115920123",
      blockNumber: 210039221,
      timestamp: 1767515239
    },
    {
      entityId: 4,
      metric: "reserve0",
      value: "7930005794349216190",
      blockNumber: 210035102,
      timestamp: 1767511202
    }
  ],
  runs: [
    { id: 3, status: "ok", startTs: 1767515250, endTs: 1767515253 },
    { id: 4, status: "ok", startTs: 1767524097, endTs: 1767524118 },
    { id: 5, status: "ok", startTs: 1767524118, endTs: 1767524121 }
  ]
};
